export const NON_EXISTENT_COUNTRY = 0;
export const RUSSIA = 643;
export const CHINA = 156;
export const PAKISTAN = 586;
export const TAJIKISTAN = 762;
export const KAZAKHSTAN = 398;
export const KOREA = 410;
export const UKRAINE = 804;
export const UZBEKISTAN = 860;
export const UK = 826;
export const LIECHTENSTEIN = 438;
export const USA = 840;
export const GERMANY = 276;
export const FRANCE = 250;
export const GUATEMALA = 320;
export const GREECE = 300;
export const UNITED_ARAB_EMIRATES = 784;
export const CANADA = 124;
export const NIGERIA = 566;
export const VIRTUAL_COUNTRY_BITCOIN = 1000;
export const INDIA = 356;
export const VIETNAM = 704;
export const PHILIPPINES = 608;
export const MEXICO = 484;
export const REPUBLIC_OF_SOUTH_AFRICA = 710;
export const ISRAEL = 376;
export const LEBANON = 422;
export const IRELAND = 372;
